<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2021-01-28 09:41 -->
<template>
  <div>
    <h4>PENDING SALES</h4>
    <div class="row" style="padding-left: 8px; padding-right: 8px">
      <div
        class="col-sm-3 mb-3"
        style="padding-right: 7px; padding-left:7px"
        v-for="(l, i) in list"
        :key="i"
      >
        <SaleCard :sale="l"></SaleCard>
        <button class="btn btn-primary mt-2" @click="clickAttendHandler(l.id)">
          ✔ Realizar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { StoreService } from "src/lt-module/store-module/StoreService.js";
import SaleCard from "./SaleCard.vue";
export default {
  components: {
    SaleCard
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    list: []
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.getSales();
  },

  methods: {
    clickAttendHandler(saleId) {
      //
      console.log("s", saleId);
    },
    async getSales() {
      let paginateResponse = await StoreService.getSales({
        store_id: this.storeId,
        attended: 0,
        add_products: 1
      });
      this.list = paginateResponse.data;
    }
  }
};
</script>

<style scoped></style>
